import { createFileRoute } from '@tanstack/react-router';
import { redirectToIntegrationsOverview } from '@/pages/workspaces/integrations/routing';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/integrations/all/')({
  beforeLoad: ({ params }) => redirectToIntegrationsOverview(params),
});
